module.exports = __webpack_public_path__ + "img/angular-min.1978796f.png";